import { FileFormat } from '../../../types';

const showPreviewBlacklist = [
    FileFormat.excel,
    FileFormat.docx,
    FileFormat.pptx,
    FileFormat.multilingualExcel,
    FileFormat.idml,
];
export const isPreviewButtonVisible = (fileFormat: FileFormat) => !showPreviewBlacklist.includes(fileFormat);

const showBuildDownloadBlacklist = [FileFormat.iosSdk, FileFormat.androidSdk, FileFormat.flutterSdk];
export const isBuildDownloadVisible = (fileFormat: FileFormat) => !showBuildDownloadBlacklist.includes(fileFormat);
